<onyx-data-widget
  [headingIcon]="{
    name: icon().name,
    size: 20,
    color: $any(color()),
    tooltip: icon().tooltip,
  }"
  [color]="$any(color())"
  [showHeadingAddon]="!!realizationData().time"
>
  <p heading>
    {{ realizationData().label | translate }}

    @if (realizationData().time; as realizationTime) {
      {{ realizationTime | onyxDate: 'time-date' : { separator: ' · ' } }}
    }
  </p>

  @if (realizationData().time; as realizationTime) {
    <ng-container headingAddon>
      @if (
        [OrderPointStatus.WAITING, OrderPointStatus.IN_PROGRESS].includes(
          pointStatus()
        )
      ) {
        {{
          realizationTime
            | diff: commonHelper.now()
            | duration
              : {
                  units: ['h', 'm', 's'],
                  past: true,
                  negativeSign: false,
                  plusSign: false,
                }
        }}
      } @else if (deadline(); as deadline) {
        {{
          deadline.arrival
            | diff: realizationTime
            | duration
              : {
                  past: true,
                  negativeSign: true,
                  plusSign: true,
                }
        }}
      }
    </ng-container>
  }

  <div class="items">
    @let timeWindows = pointTimeWindows().value;
    @let hasMultipleWindows = timeWindows.length > 1;

    <span
      [onyxTooltip]="tooltipTemplate"
      [onyxTooltipDisabled]="!hasMultipleWindows"
    >
      {{ pointTimeWindows().label | translate }}

      <span class="time-windows {{ color() }}">
        @if (timeWindows.at(0); as window) {
          {{ window }}

          @if (hasMultipleWindows) {
            +{{ timeWindows.length - 1 }}
          }
        } @else {
          -
        }
      </span>
    </span>

    <div class="item">
      <ng-container
        *ngTemplateOutlet="
          deadlineTemplate;
          context: {
            label: isPointToDo()
              ? 'labels.arrivalDeadlineTime'
              : 'labels.departureDeadlineTime',
            deadline: isPointToDo()
              ? deadline()?.arrival
              : deadline()?.departure,
          }
        "
      />
    </div>

    @let hasRemainingDistance = estimations()?.remainingDistance != null;
    @if (
      (hasRemainingDistance || estimations()?.arrivalTime) &&
      isPointToDo() &&
      isOrderInProgress()
    ) {
      <div class="item">
        {{ 'labels.remaining' | translate }}

        @if (telematicsItem()?.status?.offRouteData?.isCritical) {
          <onyx-icon
            class="off-route-icon {{ color() }}"
            name="vehicle-off-route-filled"
            [size]="20"
            onyxTooltip="labels.vehicleOffRoute"
          ></onyx-icon>
        }

        <span class="remaining {{ color() }}">
          @if (hasRemainingDistance) {
            {{ estimations()!.remainingDistance! | onyxDistance }}
          }

          @let remainingDuration =
            estimations()?.arrivalTime
              ? (estimations()!.arrivalTime! | diff: 'now' | async)
              : null;
          @let remainingTime =
            remainingDuration
              ? (remainingDuration | duration: { past: true })
              : '';
          @if (remainingTime) {
            @if (hasRemainingDistance) {
              {{ ' · ' }}
            }

            {{ remainingTime }}
          }
        </span>
      </div>
    }
  </div>
</onyx-data-widget>

<ng-template #tooltipTemplate>
  <div class="tooltip">
    @for (timeWindow of timeWindows; track timeWindow) {
      <p>{{ timeWindow }}</p>
    }
  </div>
</ng-template>

<ng-template let-label="label" let-deadline="deadline" #deadlineTemplate>
  {{ label | translate }}

  <span class="deadline {{ color() }}">
    @if (deadline) {
      {{ deadline | onyxDate: 'time-date' : { separator: ' · ' } }}
    } @else {
      {{ 'labels.unknownHour' | translate }}
    }
  </span>
</ng-template>
